import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import service1 from './pictures/service1.JPG';
import service2 from './pictures/service2.JPG';
import service3 from './pictures/service3.JPG';

const Service = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Annual Service Day!</h2>
                    <p class="site-post-meta">May 6th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    On May 6, WiC collaborated with @uwcom2 and the Foster Schools’s Undergraduate Business Council (UBC) for the ultimate Allen School and Foster RSO collab: Service Day! The event featured an amazing evening of community-building and philanthropy benefitting @seattlechildrens and @paws_wa! 🤝✨

                    <br></br>
                    <br></br>

                    WiC and @uw_ama worked together to create cozy fleece tie knot blankets! 🧶

                    <br></br>
                    <br></br>

                    Thanks to everyone who joined us! 
                    </p>
                    <img src={service1} alt="pic1 "/>
                    <img src={service2} alt="pic2 "/>
                    <img src={service3} alt="pic3 "/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Service;



